const ROOTS_AUTH = '/auth'
const ROOTS_DASHBOARD = '/dashboard'
const ROOTS_DASHBOARD_APP = '/dashboard/app'
const ROOTS_STARTUP_DASHBOARD = '/dashboard/startup'
const ROOTS_ADMIN_STARTUP_DASHBOARD = '/startup/dashboard'
const ROOTS_ADMIN_INVESTOR_DASHBOARD = '/investor/dashboard'
const ROOTS_ADMIN_CONFORMER_DASHBOARD = '/conformer/dashboard'
const ROOTS_ADMIN_SUPERVISOR_DASHBOARD = '/supervisor/dashboard'

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
}

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
}

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  app: ROOTS_DASHBOARD_APP,
  startup: {
    root: ROOTS_STARTUP_DASHBOARD,
    dashboard: path(ROOTS_DASHBOARD, '/startup/app'),
    startups: path(ROOTS_DASHBOARD, '/startup/startups'),
    verifications: path(ROOTS_DASHBOARD, '/startup-verification/list'),
    newStartup: path(ROOTS_DASHBOARD, '/startup/startups/create'),
    tickets: path(ROOTS_DASHBOARD, '/startup/startups/tickets'),
  },
  dashboard: {
    tickets: path(ROOTS_DASHBOARD, '/ticket'),
  },
  manageStartup: {
    root: path(ROOTS_DASHBOARD, '/manage-startup'),
    list: path(ROOTS_DASHBOARD, '/manage-startup/list'),
    editById: path(ROOTS_DASHBOARD, '/manage-startup/action'),
  },
  investor: {},
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
    dashboard: path(ROOTS_DASHBOARD, '/app'),
  },
  admin: {
    startup: path(ROOTS_ADMIN_STARTUP_DASHBOARD, '/app'),
    investor: path(ROOTS_ADMIN_INVESTOR_DASHBOARD, '/app'),
    conformer: path(ROOTS_ADMIN_CONFORMER_DASHBOARD, '/app'),
    supervisor: path(ROOTS_ADMIN_SUPERVISOR_DASHBOARD, '/app'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey'),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account'),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
    productById: path(
      ROOTS_DASHBOARD,
      '/e-commerce/product/nike-air-force-1-ndestrukt'
    ),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    editById: path(
      ROOTS_DASHBOARD,
      '/e-commerce/product/nike-blazer-low-77-vintage/edit'
    ),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
    postById: path(
      ROOTS_DASHBOARD,
      '/blog/post/apply-these-7-secret-techniques-to-improve-event'
    ),
    newPost: path(ROOTS_DASHBOARD, '/blog/new-post'),
  },
}

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction'

function path(root, sublink) {
  return `${root}${sublink}`
}
